import React, {
    useState
} from "react";

import {
    FontAwesomeIcon
} from "@fortawesome/react-fontawesome";

import {
    useHistory
} from "react-router-dom";


export default function UtilisationFooter()
{

    //--------------------------------------------------------
    // History
    //--------------------------------------------------------

    const history =
        useHistory();


    //--------------------------------------------------------
    // Hover
    //--------------------------------------------------------

    const [hoveredItem, setHoveredItem] =
        useState(null);


    //--------------------------------------------------------
    // Navigation
    //--------------------------------------------------------

    const goDashboardSummary =
        function()
        {
            history.push(
                "/homeutilisation"
            );
        };


    const goDashboardDepartment =
        function()
        {
            history.push(
                "/utilisationsummaryorganisation/-100"
            );
        };


    const goUsageInspector =
        function()
        {
            history.push(
                "/usageinspector"
            );
        };


    //========================================================
    // Styles
    //========================================================


    //--------------------------------------------------------
    // Main footer
    //--------------------------------------------------------

    const footerNavigatorContainer =
    {
        position:
            "fixed",

        bottom:
            "0",

        left:
            "100px",

        right:
            "40px",

        height:
            "70px",

        /*
         * Navigation stays black.
         */

        background:
            "linear-gradient(" +
                "180deg," +
                "#11161b 0%," +
                "#090d11 100%" +
            ")",

        /*
         * Structural element = square.
         */

        borderRadius:
            "0px",

        borderTop:
            "1px solid rgba(141,200,240,0.14)",

        boxShadow:
            "0 -6px 18px rgba(7,28,49,0.14)",

        display:
            "flex",

        alignItems:
            "stretch",

        zIndex:
            1500,

        overflow:
            "hidden"
    };


    //--------------------------------------------------------
    // Navigation segment
    //--------------------------------------------------------

    const getNavigatorStyle =
        function(index)
        {

            const hovered =
                hoveredItem === index;


            return {

                display:
                    "flex",

                height:
                    "100%",

                minWidth:
                    "260px",

                padding:
                    "0 28px",

                boxSizing:
                    "border-box",

                alignItems:
                    "center",

                cursor:
                    "pointer",

                userSelect:
                    "none",

                background:
                    hovered
                        ?
                        "rgba(141,200,240,0.07)"
                        :
                        "transparent",

                borderRight:
                    "1px solid rgba(255,255,255,0.10)",

                transition:
                    "background 0.18s ease"

            };

        };


    //--------------------------------------------------------
    // Icon holder
    //--------------------------------------------------------

    const getIconContainerStyle =
        function(index)
        {

            const hovered =
                hoveredItem === index;


            return {

                display:
                    "flex",

                width:
                    "38px",

                height:
                    "38px",

                alignItems:
                    "center",

                justifyContent:
                    "center",

                /*
                 * No more floating circle.
                 */

                borderRadius:
                    "0px",

                color:
                    hovered
                        ?
                        "#8dc8f0"
                        :
                        "rgba(255,255,255,0.78)",

                transform:
                    hovered
                        ?
                        "translateY(-1px)"
                        :
                        "translateY(0)",

                transition:
                    "color 0.18s ease, " +
                    "transform 0.18s ease"

            };

        };


    //--------------------------------------------------------
    // Icon
    //--------------------------------------------------------

    const iconStyle =
    {
        width:
            "24px",

        height:
            "24px"
    };


    //--------------------------------------------------------
    // Label
    //--------------------------------------------------------

    const getLabelStyle =
        function(index)
        {

            const hovered =
                hoveredItem === index;


            return {

                display:
                    "flex",

                marginLeft:
                    "14px",

                fontSize:
                    "14px",

                fontWeight:
                    500,

                color:
                    hovered
                        ?
                        "#ffffff"
                        :
                        "rgba(255,255,255,0.82)",

                transition:
                    "color 0.18s ease"

            };

        };


    //========================================================
    // Render
    //========================================================

    return (

        <div
            style={
                footerNavigatorContainer
            }
        >


            {/* ================================================
                UTILISATION SUMMARY
            ================================================= */}

            <div

                style={
                    getNavigatorStyle(1)
                }

                onClick={
                    goDashboardSummary
                }

                onMouseEnter={
                    function()
                    {
                        setHoveredItem(1);
                    }
                }

                onMouseLeave={
                    function()
                    {
                        setHoveredItem(null);
                    }
                }
            >

                <div
                    style={
                        getIconContainerStyle(1)
                    }
                >

                    <FontAwesomeIcon
                        icon="chart-bar"
                        style={iconStyle}
                    />

                </div>


                <div
                    style={
                        getLabelStyle(1)
                    }
                >

                    Utilisation Summary

                </div>

            </div>


            {/* ================================================
                DEPARTMENTAL SUMMARY
            ================================================= */}

            <div

                style={
                    getNavigatorStyle(2)
                }

                onClick={
                    goDashboardDepartment
                }

                onMouseEnter={
                    function()
                    {
                        setHoveredItem(2);
                    }
                }

                onMouseLeave={
                    function()
                    {
                        setHoveredItem(null);
                    }
                }
            >

                <div
                    style={
                        getIconContainerStyle(2)
                    }
                >

                    <FontAwesomeIcon
                        icon="users"
                        style={iconStyle}
                    />

                </div>


                <div
                    style={
                        getLabelStyle(2)
                    }
                >

                    Departmental Summary

                </div>

            </div>


            {/* ================================================
                USAGE INSPECTOR
            ================================================= */}

            <div

                style={{
                    ...getNavigatorStyle(3),

                    borderRight:
                        "1px solid rgba(255,255,255,0.10)"
                }}

                onClick={
                    goUsageInspector
                }

                onMouseEnter={
                    function()
                    {
                        setHoveredItem(3);
                    }
                }

                onMouseLeave={
                    function()
                    {
                        setHoveredItem(null);
                    }
                }
            >

                <div
                    style={
                        getIconContainerStyle(3)
                    }
                >

                    <FontAwesomeIcon
                        icon="table"
                        style={iconStyle}
                    />

                </div>


                <div
                    style={
                        getLabelStyle(3)
                    }
                >

                    Usage Inspector

                </div>

            </div>


        </div>

    );

}